import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import CardGiftcardRoundedIcon from '@mui/icons-material/CardGiftcardRounded';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import { PRO_OFFER_SUMMARY } from '../../constants/proPricing';
import {
  Band,
  BandCopy,
  BandIcon,
  BandOffer,
  BandText,
  BandTitle,
  JoinButton,
} from './ProBand.styled';

/** Home page invite for service businesses to list on NKY Connect. */
const ProBand = () => (
  <Band aria-labelledby="pro-band-title">
    <BandIcon aria-hidden>
      <StorefrontRoundedIcon />
    </BandIcon>
    <BandCopy>
      <BandTitle id="pro-band-title">
        Run a home-service business in Northern Kentucky?
      </BandTitle>
      <BandText>
        Get found by local homeowners searching for your trade right now.
      </BandText>
    </BandCopy>
    <BandOffer>
      <CardGiftcardRoundedIcon aria-hidden />
      {PRO_OFFER_SUMMARY}
    </BandOffer>
    <JoinButton component={RouterLink} to="/provider-signup">
      Join as a pro
    </JoinButton>
  </Band>
);

export default ProBand;
